// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /*base*/
    --black-color: #000;
    --default-indent: 16px;
    --default-indent-double: calc(var(--default-indent) * 2);
    --text-main: #171a2f;

    /*project colors*/
    --primary-default: #1c2140;
    --primary-hovered: #1c2140;
    --primary-active: #fdca2d;
    --primary-disabled: #f8d97b;
    --border-default: #cbcbdc;
    --secondary-default: #4aa987;
    --secondary-hovered: #69c6a4;
    --secondary-active: #429d7c;
    --secondary-disabled: #9fcfbe;
    --surface-main: #f9f8f6;
    --surface-secondary: #e0e0ea;
    --surface-default: #fff;
    --surface-hovered: #f8eee0;
    --surface-selected: #fff;
    --surface-disabled: #fefeff;
    --on-surface-text-on-primary: #212121;
    --on-surface-text-main: #212121;
    --on-surface-text-secondary: #424242;
    --on-surface-text-secondary-subdued: #878e95;
    --on-surface-border-default: #cbcbdc;
    --on-surface-border-subdued: #e3e3e9;
    --success-default: #2e9c42;
    --success-highlight: #7fc898;
    --success-surface: #cfdfd1;
    --warning-default: #cb9038;
    --warning-highlight: #f8c984;
    --warning-surface: #f3ebd4;
    --critical-default: #d75353;
    --critical-highlight: #eca2a2;
    --critical-surface: #eed6d6;
    --option-border-color: #d4dae0;
    --brand-primary: #f09f8f;
    --stroke-color: #d4dae0;
    --button-paypal-color: #f9c456;
    --action-main: #575757;
    --decorative-a: #ff5555;
    --decorative-b: #4aa987;
    --decorative-c: #fff;
    --decorative-d: #7249c9;
    --decorative-e: #f2f4f6;
    --decorative-f: #f8eee0;
    --decorative-safe: #f26f10;
    --decorative-safe-surface: #d4e4f3;
    --decorative-discount: #443ac0;
    --info-default: #1975ff;
    --info-surface: #e0e9ff;
    --additional-normal: #7dc94f;

    /*DO NOT USE*/

    /*color on unused pages. Color from Fast. Unused props*/
    --brand-primary-male: #ff964f;
    --logo-color: #d4dae0;
    --default-unit-input: #a6b3e4;
    --logo-color-fast: #252d48;
    --surface-main-fast: #f2efee;
    --experiment-purpleLight: #f6f6fd;
    --safeLight: #1975ff;
    --text-main-secondary: #292e33;
    --background-subdude: #f2f2f2;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,mBAAmB;IACnB,sBAAsB;IACtB,wDAAwD;IACxD,oBAAoB;;IAEpB,iBAAiB;IACjB,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,0BAA0B;IAC1B,wBAAwB;IACxB,2BAA2B;IAC3B,qCAAqC;IACrC,+BAA+B;IAC/B,oCAAoC;IACpC,4CAA4C;IAC5C,oCAAoC;IACpC,oCAAoC;IACpC,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;IAC9B,wBAAwB;IACxB,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,kCAAkC;IAClC,8BAA8B;IAC9B,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;;IAE5B,aAAa;;IAEb,uDAAuD;IACvD,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,4BAA4B;IAC5B,iCAAiC;IACjC,oBAAoB;IACpB,8BAA8B;IAC9B,6BAA6B;AACjC","sourcesContent":[":root {\n    /*base*/\n    --black-color: #000;\n    --default-indent: 16px;\n    --default-indent-double: calc(var(--default-indent) * 2);\n    --text-main: #171a2f;\n\n    /*project colors*/\n    --primary-default: #1c2140;\n    --primary-hovered: #1c2140;\n    --primary-active: #fdca2d;\n    --primary-disabled: #f8d97b;\n    --border-default: #cbcbdc;\n    --secondary-default: #4aa987;\n    --secondary-hovered: #69c6a4;\n    --secondary-active: #429d7c;\n    --secondary-disabled: #9fcfbe;\n    --surface-main: #f9f8f6;\n    --surface-secondary: #e0e0ea;\n    --surface-default: #fff;\n    --surface-hovered: #f8eee0;\n    --surface-selected: #fff;\n    --surface-disabled: #fefeff;\n    --on-surface-text-on-primary: #212121;\n    --on-surface-text-main: #212121;\n    --on-surface-text-secondary: #424242;\n    --on-surface-text-secondary-subdued: #878e95;\n    --on-surface-border-default: #cbcbdc;\n    --on-surface-border-subdued: #e3e3e9;\n    --success-default: #2e9c42;\n    --success-highlight: #7fc898;\n    --success-surface: #cfdfd1;\n    --warning-default: #cb9038;\n    --warning-highlight: #f8c984;\n    --warning-surface: #f3ebd4;\n    --critical-default: #d75353;\n    --critical-highlight: #eca2a2;\n    --critical-surface: #eed6d6;\n    --option-border-color: #d4dae0;\n    --brand-primary: #f09f8f;\n    --stroke-color: #d4dae0;\n    --button-paypal-color: #f9c456;\n    --action-main: #575757;\n    --decorative-a: #ff5555;\n    --decorative-b: #4aa987;\n    --decorative-c: #fff;\n    --decorative-d: #7249c9;\n    --decorative-e: #f2f4f6;\n    --decorative-f: #f8eee0;\n    --decorative-safe: #f26f10;\n    --decorative-safe-surface: #d4e4f3;\n    --decorative-discount: #443ac0;\n    --info-default: #1975ff;\n    --info-surface: #e0e9ff;\n    --additional-normal: #7dc94f;\n\n    /*DO NOT USE*/\n\n    /*color on unused pages. Color from Fast. Unused props*/\n    --brand-primary-male: #ff964f;\n    --logo-color: #d4dae0;\n    --default-unit-input: #a6b3e4;\n    --logo-color-fast: #252d48;\n    --surface-main-fast: #f2efee;\n    --experiment-purpleLight: #f6f6fd;\n    --safeLight: #1975ff;\n    --text-main-secondary: #292e33;\n    --background-subdude: #f2f2f2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
